<script setup lang="ts">
import { computed, defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Language {
	value: string;
	label: string;
	flagClass: string;
	default?: boolean;
}

const props = defineProps<{
	modelValue: string;
	availableLanguages: Language[];
}>();

const emit = defineEmits<{
	(e: 'update:modelValue', value: string): void;
}>();

const modelValue = computed({
	get: () => props.modelValue,
	set: (val: string) => emit('update:modelValue', val),
});

const selectedLanguage = computed(() => props.availableLanguages.find((lang) => lang.value === modelValue.value));
</script>

<template>
	<div class="flex flex-col items-start gap-2">
		<ion-list class="ion-no-padding w-full bg-transparent">
			<ion-item v-for="language in availableLanguages" :key="language.value" class="text-white font-sourcesanspro-regular cursor-pointer" lines="none" :class="{ 'selected': modelValue === language.value }" @click="modelValue = language.value">
				<ion-radio :value="language.value" :checked="modelValue === language.value" class="mr-4"></ion-radio>
				<ion-label class="flex items-center">
					<span :class="language.flagClass" class="mr-2" style="width: 1.5em; height: 1em"></span>
					<span class="text-white font-sourcesanspro-regular">{{ t(language.label) }}</span>
				</ion-label>
			</ion-item>
		</ion-list>
	</div>
</template>

<style scoped>
:deep(ion-item) {
	--inner-border-width: 0 !important;
	--border-color: transparent !important;
	border: none !important;
	--background: transparent;
}
</style>
